module.exports = __webpack_public_path__ + "static/media/icon_gif.69f15634.svg";